import { render, staticRenderFns } from "./TimeModule.vue?vue&type=template&id=2e84d74c&scoped=true&"
import script from "./TimeModule.vue?vue&type=script&lang=js&"
export * from "./TimeModule.vue?vue&type=script&lang=js&"
import style0 from "./TimeModule.vue?vue&type=style&index=0&id=2e84d74c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e84d74c",
  null
  
)

export default component.exports